import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import lookbookUnavailable from '../../assets/images/lookbook-unavailable.svg';

type PublicCatalogNotFoundProps = {
  onRetry: () => void;
};

const PublicCatalogNotFound = ({ onRetry }: PublicCatalogNotFoundProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4">
      <div className="max-w-lg text-center">
        <img
          src={lookbookUnavailable}
          alt={t('marketplace.catalogues.lookbook.not_found_art')!}
          className="mx-auto mb-6 w-[220px] max-w-full"
        />
        <h1
          className="font-light tracking-[0.18em] text-2xl uppercase text-foreground sm:text-3xl"
          style={{ fontFamily: 'trajan-pro-regular, Inter, serif' }}
        >
          {t('marketplace.catalogues.not_found')}
        </h1>
        <p className="mt-4 text-sm font-light leading-relaxed text-muted-foreground sm:text-base">
          {t('marketplace.catalogues.lookbook.load_failed')}
        </p>
        <p className="mt-2 text-sm font-medium leading-relaxed text-foreground/80 sm:text-base">
          {t('marketplace.catalogues.lookbook.ask_boutique')}
        </p>
        <button
          type="button"
          onClick={onRetry}
          className="mt-8 inline-flex h-12 items-center justify-center gap-2 rounded-full bg-as-pink-300 px-6 text-sm font-semibold text-white btn-hover-motion hover:bg-as-pink-500"
        >
          <RefreshCw className="h-4 w-4" aria-hidden />
          {t('marketplace.catalogues.lookbook.try_again')}
        </button>
      </div>
    </div>
  );
};

export default PublicCatalogNotFound;
